import React, { Component } from 'react'
import withStyles from "@material-ui/core/styles/withStyles";
//import InputAdornment from "@material-ui/core/InputAdornment";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import NumberMaskInput from 'components/CustomInput/NumberMaskInput';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { ServicesIcon } from '../../variables/dataIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Api from '../../api/Api.js';
import ServiceEndpoints from '../../api/ServiceEndpoints';
import Button from '../../components/CustomButtons/Button';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

class AddService extends Component {

    state = {
        name: '',
        nameState: '',
        stock_code: '',
        stock_codeState: '',
        cost: 0,
        costFormatted: 'R0.00',
        provider: '',
        providerState: '',
        company: 'Cellfind',
        adhoc: false
    }

    submit() {
        if (
            this.state.nameState === "success" &&
            this.state.stock_codeState === "success" &&
            this.state.providerState === "success"
        ) {
            Api.post(ServiceEndpoints.add, this.state)
                .then(({ data }) => {

                })
                .catch((e) => {
                    console.error(e)
                })
        } else {
            var newState = {};

            if (this.state.nameState !== "success")
                newState.nameState = "error";

            if (this.state.stock_codeState !== "success")
                newState.stock_codeState = "error";

            if (this.state.providerState !== "success")
                newState.providerState = "error";

            this.setState({ ...newState });
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8} lg={6}>
                    <Card className={classes.container}>
                        <CardBody className={classes.content}>
                            <h3 className={classes.infoText}>
                                <FontAwesomeIcon style={{ marginRight: 8 }} icon={ServicesIcon} />
                                Add Service
                            </h3>

                            <CustomInput
                                success={this.state.nameState === "success"}
                                error={this.state.nameState === "error"}
                                labelText={
                                    <span>
                                        Service Name <small>(required)</small>
                                    </span>
                                }
                                id="name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ name: event.target.value, nameState: event.target.value ? "success" : "error" }),
                                    value: this.state.name,
                                }}
                            />

                            <CustomInput
                                success={this.state.stock_codeState === "success"}
                                error={this.state.stock_codeState === "error"}
                                labelText={
                                    <span>
                                        Stock Code <small>(required)</small>
                                    </span>
                                }
                                id="stock_code"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ stock_code: event.target.value, stock_codeState: event.target.value ? "success" : "error" }),
                                    value: this.state.stock_code,
                                }}
                            />

                            <NumberMaskInput
                                labelText={
                                    <span>Cost</span>
                                }
                                id="cost"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ cost: event.target.floatValue, costFormatted: event.target.formattedValue }),
                                    value: this.state.costFormatted
                                }}
                            />

                            <CustomInput
                                success={this.state.providerState === "success"}
                                error={this.state.providerState === "error"}
                                labelText={
                                    <span>
                                        Provider <small>(required)</small>
                                    </span>
                                }
                                id="provider"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ provider: event.target.value, providerState: event.target.value ? "success" : "error" }),
                                    value: this.state.provider,
                                }}
                            />

                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <InputLabel
                                    htmlFor="company"
                                    className={classes.selectLabel}
                                    shrink
                                >
                                    Company / Legal Entity
                                </InputLabel>
                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={this.state.company}
                                    onChange={(event) => this.setState({ company: event.target.value })}
                                    inputProps={{
                                        name: "company",
                                        id: "company"
                                    }}
                                    color="rose"
                                >
                                    <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Choose Company</MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="Cellfind">
                                        Cellfind
                                    </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="Panacea">
                                        Panacea
                                    </MenuItem>
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem,
                                            selected: classes.selectMenuItemSelected
                                        }}
                                        value="Simigenix">
                                        Simigenix
                                    </MenuItem>
                                </Select>
                            </FormControl>

                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.adhoc}
                                        onChange={(event) => this.setState({ adhoc: event.target.checked })}
                                        value={this.state.adhoc}
                                        classes={{
                                            switchBase: classes.switchBase,
                                            checked: classes.switchChecked,
                                            icon: classes.switchIcon,
                                            iconChecked: classes.switchIconChecked,
                                            bar: classes.switchBar
                                        }}
                                    />
                                }
                                classes={{
                                    label: classes.label
                                }}
                                label="Adhoc Service?"
                            />

                            <br />

                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <Button round color="rose" onClick={() => this.submit()}>
                                    Create New Service
                                    &nbsp;&nbsp;&nbsp;<FontAwesomeIcon icon={faCheck} />
                                </Button>
                            </div>

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        )
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(AddService);